import React from 'react';

import ActionButton from 'components/action-button';
import { t } from 'state/intl/translations';

import { ContentContainer, DialogContainer, ModalBody, ModalHeading } from './styled';
import { IErrorRemovingLastFavoriteStoreModalProps } from './types';

export const ErrorRemovingLastFavoriteStoreModal = ({
  onDismiss,
}: IErrorRemovingLastFavoriteStoreModalProps) => {
  return (
    <DialogContainer
      showDialog
      testID="error-remove-last-favorite-store-dialog"
      headingComponent={
        <ModalHeading testID="error-remove-last-favorite-store-heading">
          {t('cannotRemoveStoreFromFavoritesHeader')}
        </ModalHeading>
      }
      bodyComponent={
        <ContentContainer testID="error-remove-last-favorite-store-body">
          <ModalBody>{t('cannotRemoveStoreFromFavorites')}</ModalBody>
        </ContentContainer>
      }
      actions={
        <ActionButton
          fullWidth
          testID="error-remove-last-favorite-store-button"
          onPress={onDismiss}
        >
          {t('okayButtonText')}
        </ActionButton>
      }
      modalAppearanceEventMessage="Cannot Remove Last Favorite Store Modal"
      isErrorModal
      onDismiss={onDismiss}
    />
  );
};
